/* BaseScheduleRenderer.js */

"use strict";

class BaseScheduleRenderer {
    constructor(model) {
        this._model = model;
        this._rendered = false;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    set rendered(rendered) {
        this.setRendered(rendered);
    }

    setRendered(rendered) {
        this._rendered = rendered;
    }

    get rendered() {
        return this.isRendered();
    }

    isRendered() {
        return this._rendered;
    }

    getParts() {
        throw new Error("getParts not implemented");
    }

    shutdown() {
        this._rendered = false;
        this._unregisterListeners();
    }

    _registerListeners() {
        this._model.on("UserValue", (this._onScheduleValue = this._onScheduleValue.bind(this)));
        this._model.on("Theme", (this._onTheme = this._onTheme.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeListener("UserValue", this._onScheduleValue);
        this._model.removeListener("Theme", this._onTheme);
    }

    _onScheduleValue() {
        this._setControlValuesFromModel();
    }

    _onTheme(newVal, oldVal) {
        this._setTheme(newVal, oldVal);
    }

    _setTheme(newTheme, oldTheme) {
        let components = this.getParts();
        if (newTheme !== oldTheme) {
            components.forEach((component) => {
                if (component) {
                    if (component instanceof Node) {
                        if (newTheme) {
                            component.classList.add(newTheme);
                        }
                        if (oldTheme) {
                            component.classList.remove(oldTheme);
                        }
                    } else {
                        component.theme = newTheme;
                    }
                }
            });
        }
    }

    _setControlValuesFromModel() {
        throw new Error("_setControlValuesFromModel not implemented");
    }
}

module.exports = BaseScheduleRenderer;
